'use client';

import { useEffect } from 'react';
// Side-effect import: initializes the install-prompt capture bridge on EVERY
// route (this component is mounted in the root layout <body>), not just the
// authenticated shell — so a beforeinstallprompt fired on the login page is
// still observed. See installPromptStore.ts.
import './installPromptStore';

/**
 * Registers the zero-caching service worker at `/sw.js`. It satisfies Chrome's
 * installability criteria and handles Web Push wakes through `/sw-wake.js`; it
 * caches nothing, so there's no stale-content or per-user-data-leak risk.
 * Registration is fire-and-forget and failures are swallowed, so a failed
 * registration costs installability and the wake on this device: the wake device
 * store races `navigator.serviceWorker.ready` because of it, as `ready` then never
 * settles. Mounted once in the root layout; renders nothing.
 */
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    // `updateViaCache: 'none'` forces the browser to revalidate sw.js on every
    // update check, so a future SW change propagates without HTTP-cache lag.
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {
      /* installability and the wake are progressive enhancements — ignore registration errors */
    });
  }, []);

  return null;
}
